import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli/index';
import { Icon } from '../../../../components/common/icon/Icon';
import { useLayout } from '../../../../hooks/screen/useLayout';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { userOwnTractorSurveySlice } from '../../../../store/userOwnTractorSurveySlice';

export const OwnTractorSurveyEntryPage = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const userOwnTractorActions = userOwnTractorSurveySlice.actions;

  useLayout({
    fixedHeader: <></>,
    fixedHeaderHeight: 0,
    fixedFooter: <></>,
    fixedFooterHeight: 0,
  });

  useEffect(() => {
    dispatch(userOwnTractorActions.resetState());
  }, [dispatch, userOwnTractorActions]);

  return (
    <Container>
      <HeaderSection>
        <BackButton onClick={() => navigate('/home')}>
          <Icon name={'ArrowLeft'} width={20} height={20} />
        </BackButton>
      </HeaderSection>

      <ContentSection>
        <IconWrap>
          <Icon name={'DocumentWrite1'} width={100} height={100} />
        </IconWrap>

        <TextContainer>
          <Title>{'고객님의 정보를 알려주세요!'}</Title>
          <Description>{'회원님께서 현재 보유 하고 계신\n트랙터에 대해서 알려주세요!'}</Description>
        </TextContainer>

        <GreyChip>
          <GreyChipText>{'예상 참여 시간'}</GreyChipText>
          <GreenChip>
            <GreenChipText>{'2분 내외'}</GreenChipText>
          </GreenChip>
        </GreyChip>
      </ContentSection>

      <ButtonContainer>
        <BottomButton
          onClick={() => {
            ampli.서베이시작버튼클릭({ '서베이 이름': '회원 보유 트랙터' });
            navigate('/survey/progress/own-tractor/required-input-overview');
          }}
        >
          <BottomButtonText>{'설문 시작!'}</BottomButtonText>
        </BottomButton>
        <GreyButton
          onClick={() => {
            navigate('/home');
          }}
        >
          <GreyButtonText>{'홈으로'}</GreyButtonText>
        </GreyButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: 24px;
  padding-bottom: 32px;

  gap: 32px;

  background-color: white;

  overflow: hidden;
`;

const HeaderSection = styled.div`
  width: 100%;

  display: flex;
`;

const BackButton = styled.button``;

const BottomButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const BottomButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const ContentSection = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 24px;
`;

const IconWrap = styled.div`
  padding: 25px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 24px */
`;

const GreyButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const ButtonContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const GreyChip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyChipText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const GreenChip = styled.div`
  display: flex;
  align-items: center;

  padding: 6px 8px;

  gap: 2px;

  border-radius: var(--radius-small, 4px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const GreenChipText = styled.div`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;
